/**
 * Formats the integer part of a number (eg: 50000.10 -> $ 50 000._)
 * If the number contains a decimal part, the decimal part is ignored.
 *
 * @param numberValue, the number to be formatted
 * @param thousandSeparator, the separator between the groups of thousands in the number
 * @param prefix, string before the number
 * @param suffix, string after the number
 *
 * @return string, the formatted number if the numberValue is a valid number, otherwise returns null
 */
import { PostAddress } from "../../api/commercial/generated-types";
import { CybwellAddress } from "../../pages/shared/components/autocomplete/address-autocomplete/types";

export function formatNumber(
  numberValue: string,
  thousandSeparator = "",
  prefix = "",
  suffix = "",
): string {
  if (Number.isNaN(Number(numberValue))) {
    return null;
  }

  const thousandRegex = /(\d)(?=(\d{3})+(?!\d))/g;
  const trimmedNumberValue = numberValue.trim();
  let indexOfDecimalSeparator = trimmedNumberValue.indexOf(".");
  indexOfDecimalSeparator =
    indexOfDecimalSeparator === -1
      ? trimmedNumberValue.length
      : indexOfDecimalSeparator;
  return (
    prefix +
    trimmedNumberValue
      .substr(0, indexOfDecimalSeparator)
      .replace(thousandRegex, "$1" + thousandSeparator) +
    suffix
  );
}

export function formatFullStreet(
  address: PostAddress | CybwellAddress,
): string {
  let fullstreet = "";
  if (!address) {
    return fullstreet;
  }

  if (address.street && address.street.length > 0) {
    fullstreet = address.street;
  }

  if (address.streetNr && address.streetNr.length > 0) {
    fullstreet =
      fullstreet.length > 0
        ? `${fullstreet} ${address.streetNr}`
        : address.streetNr;
  }

  return fullstreet;
}
